<script>
import { mapGetters } from "vuex";
// import DakGootButton from '@/components/inputs/buttons/DakGootButton.vue'
import ComponentCardDecomposed from '@/components/inputs/ComponentCardDecomposed.vue'
export default {
    components: {
      // DakGootButton,
      ComponentCardDecomposed
    },

    data () {
      return {
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        
      }
    },

    computed: {
      ...mapGetters({
        config: 'getConfig', 
        dakgoot: 'getDakgoot',
        dakgootTypes: 'getDakgootTypesPublic',
      }),

      formattedDakgootTypesVoor() {
        return this.dakgootTypes.map(type => ({
          ...type,
          shortName: type.label,
          options: [
            { name: type.textLeft, selected: this.dakgoot.front.left },
            { name: type.textRight, selected: this.dakgoot.front.right }
          ]
        }));
      },

      formattedDakgootTypesAchter() {
        return this.dakgootTypes.map(type => ({
          ...type,
          shortName: type.label,
          options: [
            { name: type.textLeft, selected: this.dakgoot.back.left },
            { name: type.textRight, selected: this.dakgoot.back.right }
          ]
        }));
      },

      dakgootVoor() {
        return this.config.dakgoot.front;
      },
      dakgootAchter() {
        return this.config.dakgoot.back;
      },

      needs2Pipes() {
        return Math.round(this.$store.getters.getDakPlaatSize.dakPlaatBreedteVoor) >= this.config.afmetingen.dakgoot.twoPipesWidth
      }
    },

    methods: {
      changeDakgoot (data) {
        this.$store.dispatch('updateDakgoot', data)
      },

      changeDakgootOption (side, data) {
        const isSelected = side === 'Voorzijde' 
          ? this.config.dakgoot.front.dakgootType === data.data.id 
          : this.config.dakgoot.back.dakgootType === data.data.id
        if (!isSelected) return
        let dakgootObject = side === 'Voorzijde' ? this.config.dakgoot.front : this.config.dakgoot.back;
        dakgootObject = JSON.parse(JSON.stringify(dakgootObject));
        dakgootObject.name = side;
        dakgootObject.left = data.index === 0
        dakgootObject.right = data.index === 1
        this.$store.dispatch('updateDakgoot', dakgootObject)
      },

      changeDakgootColor (side, data) {
        const isSelected = side === 'Voorzijde' 
          ? this.config.dakgoot.front.dakgootType === data.data.id 
          : this.config.dakgoot.back.dakgootType === data.data.id
        if (!isSelected) return
        let dakgootObject = side === 'Voorzijde' ? this.config.dakgoot.front : this.config.dakgoot.back;
        dakgootObject = JSON.parse(JSON.stringify(dakgootObject));
        dakgootObject.name = side;
        dakgootObject.dakgootColor = data.color.id;
        this.$store.dispatch('updateDakgoot', dakgootObject)
      },

      changeDakgootType (side, dakgootType, data) {
        let dakgootObject = side === 'Voorzijde' ? this.config.dakgoot.front : this.config.dakgoot.back;
        dakgootObject = JSON.parse(JSON.stringify(dakgootObject));
        if (dakgootType.id === dakgootObject.dakgootType && data?.realSelect) {
          dakgootObject.dakgootType = '';
          dakgootObject.enabled = false;
        } else {
          dakgootObject.dakgootType = dakgootType.id;
          dakgootObject.enabled = true;
        }
        if (data && data.selectedOption !== undefined && data.selectedOption !== null) {
          dakgootObject.left = data.selectedOption === 0;
          dakgootObject.right = data.selectedOption === 1;
        }
        if (data && data.selectedColor !== undefined && data.selectedColor !== null) {
          dakgootObject.dakgootColor = data.selectedColor;
        }
        dakgootObject.name = side;
        this.$store.dispatch('updateDakgoot', dakgootObject)
      }
    }
  }
</script>
<template>
  <!-- <DakGootButton
    v-if="config.availableOptions.dakgoot"
    :data="{name: 'Voorzijde', enabled: dakgoot.front.enabled, left: dakgoot.front.left, right: dakgoot.front.right}"
    @setDakgoot="changeDakgoot"
  />

  <DakGootButton
    v-if="config.availableOptions.dakgoot"
    :data="{name: 'Achterzijde', enabled: dakgoot.back.enabled, left: dakgoot.back.left, right: dakgoot.back.right}"
    @setDakgoot="changeDakgoot"
  /> -->
  <div v-if="config.availableOptions.dakgoot">

    <div class="side-header">
      <span class="side-header-text">voorzijde</span>
    </div>

    <div class="card-container">
      <ComponentCardDecomposed
        v-for="(dakgootType, index) in formattedDakgootTypesVoor"
        :key="index"
        ref="component"
        :imgUrl="`${previewsServer}/textures/${dakgootType.uiImage?.url}`"
        :title="dakgootType.label"
        :description="dakgootType.description"
        :infobox="dakgootType.infobox"
        :colors="dakgootType.colors.map(color => ({
          id: color.id,
          label: color.label,
          hexCode: color.uiHexcode
        }))"
        :allOptionsEnabled="needs2Pipes"
        :optionStartValue="1"
        :colorStartValue="
          dakgootType.colors.find(c => c.id === dakgootVoor.dakgootColor)?.id ||
          dakgootType.colors.find(c => c.isDefault)?.id ||
          dakgootType.colors[0]?.id
        "

        :data="dakgootType" 
        :selected="dakgootType.id === dakgootVoor.dakgootType"
        :scolor="dakgootType.id"
        :soption="dakgootType"
        @select="changeDakgootType('Voorzijde', dakgootType, $event)"
        @optionChanged="changeDakgootOption('Voorzijde', $event)"
        @colorChanged="changeDakgootColor('Voorzijde', $event)"
      />
    </div>


    <div class="side-header">
      <span class="side-header-text">achterzijde</span>
    </div>

    <div class="card-container">
      <ComponentCardDecomposed
        v-for="(dakgootType, index) in formattedDakgootTypesAchter"
        :key="index"
        ref="component"
        :imgUrl="`${previewsServer}/textures/${dakgootType.uiImage?.url}`"
        :title="dakgootType.label"
        :description="dakgootType.description"
        :colors="dakgootType.colors.map(color => ({
          id: color.id,
          label: color.label,
          hexCode: color.uiHexcode
        }))"
        :allOptionsEnabled="needs2Pipes"
        :optionStartValue="1"
        :colorStartValue="
          dakgootType.colors.find(c => c.id === dakgootAchter.dakgootColor)?.id ||
          dakgootType.colors.find(c => c.isDefault)?.id ||
          dakgootType.colors[0]?.id
        "

        :data="dakgootType" 
        :selected="dakgootType.id === dakgootAchter.dakgootType"
        :scolor="dakgootType.id"
        :soption="dakgootType"
        @select="changeDakgootType('Achterzijde', dakgootType, $event)"
        @optionChanged="changeDakgootOption('Achterzijde', $event)"
      />
    </div>

  </div>
</template>

<style>
.side-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* position: absolute; */
  width: 100%;
  height: 48px;

  background: #E2E8F0;
  border-radius: 8px;

  margin-top: 16px;
}

.side-header-text {
  display: flex;
  flex-direction: row;
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  line-height: 28px;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: #4A5568;
}

.card-container {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2 equal columns */
  gap: 16px;
  margin-top: 16px;
}
</style>